import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

// Loads the Unified Settings active features once for the whole my-hotel
// section so each child page (hotel-details, general-defaults, …) can read
// flags via the `has-unified-settings-active-feature` helper without re-fetching.
export default class HotelSettingsMyHotelRoute extends Route {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service('subscription-active-features')
  declare subscriptionActiveFeatures: Services['subscription-active-features'];

  async beforeModel(): Promise<void> {
    const subscriptionId = this.hotelAndMarketService.hotel.id!;
    // Soft-fail: if FF load errors, the helper returns false for every flag
    // (hiding unified controls) rather than blocking access to settings.
    // The underlying error is already captured by errorTracking inside the
    // service's loadTask.
    await this.subscriptionActiveFeatures.loadTask
      .perform(subscriptionId)
      .catch(() => {});
  }

  deactivate(): void {
    void this.subscriptionActiveFeatures.loadTask.cancelAll();
    this.subscriptionActiveFeatures.reset();
  }
}
